import { useState } from 'react';
import { supabase } from '../../lib/supabase.ts';
import Logo from '../Landing/Logo';
import { track } from '../../lib/analytics';

const SILK = "'Silkscreen', monospace";
const VT = "'VT323', monospace";
const ACCENT = '#f0c000';
const GREEN = '#39ff14';

export function LoginScreen() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function sendMagicLink(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: `${window.location.origin}/app` },
    });
    if (error) setError(error.message);
    else { track('signup_started', { method: 'magic-link' }); setSent(true); }
  }

  async function google() {
    setError(null);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/app` },
    });
    if (error) setError(error.message);
    else track('signup_started', { method: 'google' });
  }

  const inputStyle: React.CSSProperties = {
    width: '100%',
    background: '#070b09',
    border: '1px solid #2a3a2f',
    color: '#c4d2c8',
    fontFamily: VT,
    fontSize: 18,
    padding: '10px 12px',
    outline: 'none',
  };

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        background: 'radial-gradient(120% 80% at 70% -10%, #10231a 0%, #0a120d 45%, #070b09 100%)',
        fontFamily: VT,
        position: 'relative',
      }}
    >
      {/* CRT scanlines, same treatment as the landing */}
      <div style={{ pointerEvents: 'none', position: 'fixed', inset: 0, background: 'repeating-linear-gradient(to bottom, rgba(0,0,0,0.16) 0px, rgba(0,0,0,0.16) 1px, transparent 1px, transparent 3px)', mixBlendMode: 'multiply' }} />

      <div style={{ width: '100%', maxWidth: 400, border: '2px solid #24382c', background: '#090f0c', boxShadow: '0 0 0 1px #0a120d, 0 30px 70px -30px rgba(0,0,0,0.9)', padding: 28 }}>
        <div style={{ marginBottom: 10 }}>
          <Logo size={13} />
        </div>
        <div style={{ fontFamily: SILK, fontSize: 10, letterSpacing: 2, color: GREEN, marginBottom: 22 }}>
          // BUNKER ACCESS
        </div>

        {sent ? (
          <div>
            <p style={{ fontSize: 20, lineHeight: 1.35, color: '#c4d2c8', margin: '0 0 8px' }}>
              ▸ Transmission sent.
            </p>
            <p style={{ fontSize: 18, lineHeight: 1.35, color: '#8f9f94', margin: 0 }}>
              Check <span style={{ color: ACCENT }}>{email}</span> for your magic link — it opens the bunker door.
            </p>
          </div>
        ) : (
          <form onSubmit={sendMagicLink}>
            <label
              htmlFor="email"
              style={{ display: 'block', fontFamily: SILK, fontSize: 9, letterSpacing: 1, color: '#8fa196', marginBottom: 8, textTransform: 'uppercase' }}
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              autoFocus
              placeholder="you@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ ...inputStyle, marginBottom: 12 }}
            />
            <button
              type="submit"
              style={{ width: '100%', fontFamily: SILK, fontSize: 11, letterSpacing: 1, color: '#06110a', background: ACCENT, padding: '12px 0', border: `1px solid ${ACCENT}`, boxShadow: `0 0 22px -6px ${ACCENT}`, cursor: 'pointer', marginBottom: 10 }}
            >
              SEND MAGIC LINK ▸
            </button>
          </form>
        )}

        {!sent && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '6px 0 10px', color: '#3a4a3f', fontFamily: SILK, fontSize: 8, letterSpacing: 1 }}>
              <span style={{ flex: 1, height: 1, background: '#1a2a20' }} />
              OR
              <span style={{ flex: 1, height: 1, background: '#1a2a20' }} />
            </div>
            <button
              onClick={google}
              style={{ width: '100%', fontFamily: SILK, fontSize: 10, letterSpacing: 1, color: '#d6e0d8', background: 'rgba(20,32,25,0.5)', padding: '12px 0', border: '1px solid #33473a', cursor: 'pointer' }}
            >
              CONTINUE WITH GOOGLE
            </button>
          </>
        )}

        {error && (
          <p style={{ fontSize: 16, color: '#e05050', margin: '12px 0 0' }}>⚠ {error}</p>
        )}

        <p style={{ fontSize: 15, color: '#5a6a5f', margin: '18px 0 0' }}>
          No account yet? The magic link creates one. Free to start, no credit card.
        </p>
      </div>
    </div>
  );
}
